import { mockData, registerMockData, type ResultOf } from "graphql-mock"
import { times } from "lodash-es"
import { graphql } from "../../graphql"
import {
  mockProductBundleCardData,
  productBundleFragment,
} from "../ProductBundleCard/gql"
import { mockProductCardData, productCardFragment } from "../ProductCard/gql"

export type ExploreData = ResultOf<typeof exploreQuery>

export const exploreQuery = graphql(
  `
    query ExploreFilteredProducts(
      $input: ExploreContentInput
      $limit: Int!
      $page: Int
    ) {
      exploreContent(input: $input, limit: $limit, page: $page) {
        pageInfo {
          nextPage
          nextPageItemCount
        }
        nodes {
          product {
            ...ProductCard
          }
          productBundle {
            ...ProductBundleCard
          }
        }
      }
    }
  `,
  [productCardFragment, productBundleFragment]
)

export const mockExploreFilteredProductsData = mockData<ExploreData>({
  exploreContent: {
    pageInfo: {
      nextPage: null,
      nextPageItemCount: 0,
    },
    nodes: [
      ...times(16, () => ({
        product: mockProductCardData(),
        productBundle: null,
      })),
      ...times(2, () => ({
        product: null,
        productBundle: mockProductBundleCardData(),
      })),
    ],
  },
})

registerMockData(exploreQuery, mockExploreFilteredProductsData())
